import { $axios } from '@/modules/http/axios'
import axios from 'axios'

const automaticLabelsModule = {
  namespaced: true,

  state: () => ({
    labels: []
  }),

  getters: {
    getLabels (state) {
      return state.labels.sort((a, b) => {
        if (a.title.startsWith('Zmiana')) {
          return 1
        } else {
          return -1
        }
      })
    }
  },

  mutations: {
    setLabels (state, labels) {
      state.labels = labels
    }
  },

  actions: {
    async fetchLabels ({ commit }, payLoad) {
      let vehicleQueryParams = ''
      payLoad.vehicles.map(vehicle => { vehicleQueryParams += `vehicleIds=${vehicle.id}&` })

      const url = `Label?${vehicleQueryParams}fromDate=${payLoad.fromDateString}&toDate=${payLoad.toDateString}`
      const automaticLabels = (await $axios.get(url)).data

      commit('setLabels', automaticLabels)
    }
  }
}

export default automaticLabelsModule
